import React, {ReactElement, useEffect, useState} from 'react'
import {apiRequest, getErrorMessage, PATH_INFO_INDEX} from '../../common/backend'
import PageLoader from '../../common/component/PageLoader'
import M from 'materialize-css'
import {useLocation} from 'react-router'
import InfoPage from './InfoPage'
import {useTranslation} from 'react-i18next'

const Info = () => {
    const [pages, setPages] = useState<TextBlock[] | null>(null)
    const [loading, setLoading] = useState<boolean>(true)

    const {t} = useTranslation()

    const hash: number = parseInt(useLocation().hash.replace('#', ''))

    useEffect((): void => {
        apiRequest(PATH_INFO_INDEX, (res: { data: TextBlock[] }): void => {
            setPages(res.data)
            // @ts-ignore
        }, err => {
            M.toast({html: getErrorMessage(err), classes: 'rounded red large'})
        }, undefined, 'GET')!!
            .finally((): void => {
                setLoading(false)
            })
    }, [])

    return <div className="center">
        {loading && <PageLoader/>}
        <div style={{
            maxWidth: '100%',
            width: '80%',
            margin: 'auto'
        }}>
            <h4>{t('info.header')}</h4>
            <br/>
            <nav className="nav-extended">
                <div className="nav-content">
                    <ul className="tabs tabs-transparent">
                        {pages?.map((it: TextBlock): ReactElement => {
                            return <li key={it.id} className={it.id === hash ? 'tab active' : 'tab'}>
                                <a className={it.id === hash ? 'active' : ''} href={'#' + it.id}>{it.name}</a>
                            </li>
                        })}
                    </ul>
                </div>
            </nav>
            <br/>
            <InfoPage key={hash} id={hash}/>
        </div>
    </div>
}
export default Info